module.exports = __webpack_public_path__ + "img/illust-enginner-section-link.2403b698.png";